import { getFinalBikePrice, getFinalGlassPrice, getFinalPremium, getRecommendedInsuredSum, formatPostcode, isValidPostcode, getNearestCentRoundedValue, calculateInsuredSumFromPrice, } from './utils';
import { contributionRatesByPostcode } from './rates';
export var getHouseholdPrices = function (_a) {
    var postcode = _a.postcode, propertyInSqMeters = _a.propertyInSqMeters, insuredSum = _a.insuredSum, _b = _a.hasSecurityDevice, hasSecurityDevice = _b === void 0 ? false : _b, bikeInsuredSum = _a.bikeInsuredSum;
    if (!isValidPostcode(postcode)) {
        return null;
    }
    var formattedPostcode = formatPostcode(postcode);
    var _c = contributionRatesByPostcode[formattedPostcode], basicContributionRate = _c.basic, extendedContributionRate = _c.extended, bikeContributionRate = _c.bike;
    var basicPremium = getFinalPremium(basicContributionRate, insuredSum, hasSecurityDevice);
    var extendedPremium = getFinalPremium(extendedContributionRate, insuredSum, hasSecurityDevice);
    var recommendedInsuredSum = getRecommendedInsuredSum(propertyInSqMeters);
    var glassPrice = getFinalGlassPrice(propertyInSqMeters, hasSecurityDevice);
    var bikePrice = getFinalBikePrice({
        insuredSum: insuredSum,
        bikeInsuredSum: bikeInsuredSum,
        bikeContributionRate: bikeContributionRate,
        hasSecurityDevice: hasSecurityDevice,
    });
    return {
        basicPremium: getNearestCentRoundedValue(basicPremium),
        extendedPremium: getNearestCentRoundedValue(extendedPremium),
        glassPrice: getNearestCentRoundedValue(glassPrice),
        bikePrice: getNearestCentRoundedValue(bikePrice),
        recommendedInsuredSum: getNearestCentRoundedValue(recommendedInsuredSum),
    };
};
export { isValidPostcode, getRecommendedInsuredSum, calculateInsuredSumFromPrice, };
